import { Component, OnInit } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { EntityComponent } from 'src/app/modules/here/components/entity/entity.component';
import { PopoverService } from 'src/app/services/utl/ctrl/ctrl.service';
import { AddressService } from 'src/app/services/core/address.service';

@Component({
  selector: 'app-delivery-order',
  templateUrl: './delivery-order.component.html',
  styleUrls: ['./delivery-order.component.scss'],
})
export class DeliveryOrderComponent implements OnInit {

  ctrl;

  constructor(
    private alert: AlertController,
    private popover: PopoverService,
    private address: AddressService
  ) { }

  ngOnInit() {}

  pickup: string;
  dropoffs = [];

  // async add() {
  //   const c = await this.alert.create({
  //     header: 'Customer',
  //     inputs: [
  //       {
  //         name: 'name',
  //         type: 'text',
  //         placeholder: 'Name'
  //       },
  //       {
  //         name: 'address',
  //         type: 'text',
  //         placeholder: 'Address',
  //       },
  //       {
  //         name: 'phone',
  //         type: 'tel',
  //         placeholder: 'Phone',
  //       },
  //       {
  //         name: 'manifest',
  //         type: 'text',
  //         placeholder: 'Food Items',
  //       },
  //     ],
  //     buttons: [
  //       {
  //         text: 'Cancel',
  //         handler: async () => {
  //           return 0;
  //         }
  //       },
  //       {
  //         text: 'Add',
  //         handler: async (r: any) => {
  //           this.dropoffs.push(r);
  //         }
  //       }
  //     ]
  //   });
  //   await c.present();
  // }

  send(data) {
    if(this.dropoffs.length == 0)
    return alert('At least one customer is required');

    const {date, time/*, pickup*/} = data?.value;
    const r = {
      performAt: new Date(date+'T'+time),
      status: 'scheduled',
      dropoffs: this.dropoffs,
      pickup: this.pickup
    };
    this.ctrl.dismiss(r);
  }
  
  async add(p?:string) {
    const r = await this.popover.show({
      component: EntityComponent,
      items: {
        title: 'Customer',
        return: 'geocode',
        placeholder: p||'Address...',
      },
      cssClass: 'wide top-mobile',
		  backdropDismiss: false,
    });
    if(r)
    this.dropoffs.push(r);
  }

  async setPickup() {
      try {
          this.pickup = await this.address.get()
      } catch (e) {
          console.log(e)
      }
  }

}
